var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransitionTabGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "12px",
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2799 3.41625C15.9234 3.41625 16.4451 2.89459 16.4451 2.25109C16.4451 1.60759 15.9234 1.08594 15.2799 1.08594C14.6364 1.08594 14.1147 1.60759 14.1147 2.25109C14.1147 2.89459 14.6364 3.41625 15.2799 3.41625Z",
    fill: "#20e290"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12264 3.08624L5.49756 2.42847C5.92452 2.02374 6.48356 1.80078 7.07137 1.80078H7.23417V2.70767H7.07137C6.71633 2.70701 6.38091 2.84301 6.12264 3.08624Z",
    fill: "#20e290"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.435 1.79688H11.8984V2.70376H13.435V1.79688Z",
    fill: "#20e290"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2832 6.48016L10.6291 5.64062C11.2359 5.89105 11.7053 6.38993 11.9204 7.00847L11.0619 7.30401C10.9338 6.93066 10.6494 6.62924 10.2832 6.48016Z",
    fill: "#20e290"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9606 8.4375L11.7505 8.88473C11.4262 9.45685 10.873 9.86223 10.2323 9.99627L10.0439 9.11031C10.431 9.02727 10.7638 8.78273 10.9606 8.4375Z",
    fill: "#20e290"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3441 1.79688H8.78857V2.70376H10.3441V1.79688Z",
    fill: "#20e290"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91943 5.46875H7.36523V6.37629H8.91943V5.46875Z",
    fill: "#20e290"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5861 9.13672H7.03125V10.0436H8.5861V9.13672Z",
    fill: "#20e290"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69203 4.13281C5.70707 4.52904 5.8908 4.89912 6.19549 5.1502L5.62272 5.85112C5.11338 5.43462 4.81065 4.82066 4.78711 4.16354L5.69203 4.13281Z",
    fill: "#20e290"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47672 9.13672H3.92188V10.0436H5.47672V9.13672Z",
    fill: "#20e290"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23747 9.5895L0.688236 9.03962C0.511044 8.86373 0.511044 8.57604 0.686928 8.39754C0.863467 8.22165 1.15116 8.22165 1.3277 8.39754L1.87954 8.94808L2.42943 8.39754C2.60662 8.22165 2.89431 8.22165 3.07151 8.39754C3.24804 8.57538 3.24804 8.86373 3.07151 9.03962L2.52031 9.5895L3.07151 10.1387C3.24804 10.3159 3.24804 10.6043 3.07151 10.7802C2.98193 10.8697 2.86554 10.9135 2.74851 10.9135C2.63277 10.9135 2.5177 10.8697 2.42943 10.7802L1.87954 10.2283L1.3277 10.7802C1.24074 10.8697 1.12304 10.9135 1.00862 10.9135C0.890928 10.9135 0.775198 10.8697 0.686928 10.7802C0.51039 10.6043 0.51039 10.3159 0.688236 10.1387L1.23747 9.5895Z",
    fill: "#20e290"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransitionTabGreen);
export default __webpack_public_path__ + "static/media/transition_tab_green.55c048d0c4ef63b430a6d2e560cba40c.svg";
export { ForwardRef as ReactComponent };